<template>
    <div>
        <h2>Top Tweets
            <select class="form-control tweets-select" v-model="selected">
                <option v-for="option in options" :value="option.id">{{option.name}}</option>
            </select>
        </h2>
        <div :class="locked" s class="tweets-wrapper">
            <div v-masonry ref="tweets" data-masonry='{ "itemSelector": ".tweets-grid-item", "columnWidth": 300, "gutter":20 }' class="tweets-grid">
                <div v-masonry-tile class="tweets-grid-item" v-for="tweet in data[selected]" :key="tweet.id">
                    <Tweet :id="tweet.id" :tweet="tweet"/>
                </div>
            </div>
            <div class="unlock-button-wrapper">
                <button @click="unlock" class="unlock btn btn-upgrade btn-large"><i class="fa fa-unlock"></i> Unlock real report for #{{hashtag}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Tweet from './Tweet'
    import Vue from 'vue'

    export default {
        name: 'Tweets',
        props: ['tweets', 'locked', 'hashtag'],
        components: {
            Tweet
        },
        data () {
            return {
                data: {},
                selectedTweets: [],
                selected: '',
                options: [
                    {'name': 'Most positive', 'id': 'positive'},
                    {'name': 'Most negative', 'id': 'negative'},
                    {'name': 'Most engagement', 'id': 'engagement'},
                    {'name': 'Most likes', 'id': 'likes'},
                    {'name': 'Most retweets', 'id': 'retweets'},
                    {'name': 'Most replies', 'id': 'replies'}
                ]
            }
        },
        methods: {
            unlock () {
                this.$parent.$emit('unlock')
            }
        },
        watch: {
            tweets (tweets) {
                for (let i of this.options) {
                    this.data[i.id] = tweets[i.id].map(tweet => {
                        return {
                            id: tweet.tweetId,
                            name: tweet.account_name,
                            screen_name: tweet.account,
                            text: tweet.text,
                            lang: tweet.lang,
                            created_at: moment(String(tweet.date)).format('MMM DD, YYYY'),
                            media: tweet.media
                        }
                    })
                }
                this.selected = 'engagement'
            },
            selected (selected) {
                // this.selectedTweets = this.data[selected]
                // this.$redrawVueMasonry()
            }
        },
        created () {
            this.$on('tweet.loaded', () => {
                const thiz = this
                setTimeout(() => {
                    thiz.$redrawVueMasonry()
                }, 1000)
                // Vue.nextTick().then(() => {
                //     this.$redrawVueMasonry()
                // })
            })
        }
    }
</script>

<style scoped lang="scss">
    .tweets-select {
        display: inline-block;
        width: 200px;
    }
    .tweets-wrapper {
        position: relative;
        &.locked {
            .tweets-grid {
                -webkit-filter: grayscale(100%);
                filter: grayscale(100%);
                opacity: 0.4;
                pointer-events: none;
            }
            .unlock-button-wrapper {
                display:block !important;
            }
        }
        .tweets-grid {
            width:100%;
            max-width: 940px;
            margin: 50px auto;

            .tweets-grid-item {
                width:300px;
                padding: 4px 8px;
                height: auto;
                float:left;
                //position: relative !important;
            }
        }
        .unlock-button-wrapper {
            display:none;
            width:100%;
            position: absolute;
            top: 20%;
            left: 0%;
            text-align: center;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Tweets.vue